import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, doc, setDoc, getDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC5-WoGEgDzgtX7R3ytiPS_PWbFr0IlvoI",
    authDomain: "optcg-binder.firebaseapp.com",
    projectId: "optcg-binder",
    storageBucket: "optcg-binder.firebasestorage.app",
    messagingSenderId: "139621975248",
    appId: "1:139621975248:web:3fdaa8453595bf47784ad5",
    measurementId: "G-81DKV79YXV"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const createUserDocument = async (user, params) => {
    try {
        const usersRef = collection(db, "users");
        await setDoc(doc(usersRef, user.uid), {
            email: user.email,
            nickname: params.nickname,
            owned_cards: [],
            liked_cards: [],
            wishlisted_cards: []
        });
    } catch (error) {
        console.log("Error when creating user document:", error);
    }
};

const getUserDocument = async (uid) => {
    console.log("getuserdocument");
    const usersRef = collection(db, "users")
    const docRef = doc(usersRef, uid)
    const docSnap = await getDoc(docRef)
    return docSnap.data()
}

const addCardToUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            owned_cards: arrayUnion(cardID)
        });
    } catch (error) {
        console.log("Error when adding card to user document:", error); 
    }
}

const addLikedCardToUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            liked_cards: arrayUnion(cardID)
        });
    } catch (error) {
        console.log("Error when adding liked card to user document:", error); 
    }
}

const addWishlistedCardToUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            wishlisted_cards: arrayUnion(cardID)
        });
    } catch (error) {
        console.log("Error when adding wishlisted card to user document:", error); 
    }
}

const removeCardFromUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            owned_cards: arrayRemove(cardID)
        });
    } catch (error) {
        console.log("Error when removing card from user document:", error);
    }
}

const UnlikeCardFromUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            liked_cards: arrayRemove(cardID)
        });
    } catch (error) {
        console.log("Error when unliking card from user document:", error);
    }
}

const UnwishlistCardFromUserDocument = async (uid, cardID) => {
    try {
        const userRef = doc(db, "users", uid);
        await updateDoc(userRef, {
            wishlisted_cards: arrayRemove(cardID)
        });
    } catch (error) {
        console.log("Error when unwishlisting card from user document:", error);
    }
}

const checkIfUserExists = async (user) => {
    const userRef = doc(db, "users", user.uid);
    const snap = await getDoc(userRef);
    return snap.exists()
}

export {
    app, 
    auth, 
    createUserDocument, 
    getUserDocument,
    addCardToUserDocument, 
    addLikedCardToUserDocument, 
    addWishlistedCardToUserDocument, 
    removeCardFromUserDocument,
    UnlikeCardFromUserDocument,
    UnwishlistCardFromUserDocument,
    checkIfUserExists
}